// Blue Scale
const blue1 = '#3366FF'
const blue2 = '#598BFF'
const blue3 = '#274BDB'
const blue4 = '#1A34B8'
const blue5 = '#E0E9FE'
const blue6 = '#6897FF'
const blue7 = '#8aadff'
const blue8 = '#00A5CF'
const blue9 = '#222B45'
const blue10 = '#EEF2FE'

// Gray Scale
const gray1 = '#F7F9FC' // Ghost white
const gray2 = '#EDF1F7' // Anti flash white
const gray3 = '#E4E9F2' // Glitter
const gray4 = '#C5CEE0' // Beau blue
const gray5 = '#8F9BB3' // cadet gray
const gray6 = '#999999' // Manatee
const gray7 = '#2B2B2B' // medium Jungle green
const gray8 = '#313131'
const gray9 = '#e4ebf5'
const gray10 = '#333333'
const gray11 = '#F2F2F7'
const gray12 = '#CCCCCC'
const gray13 = '#FAFAFA'
const gray14 = 'rgba(37, 42, 48, 0.66)'
const gray15 = '#252A30A8'
const grayShadeBlack2 = '#6b6a6a'

// Background
const backgroundBlue = '#cce6ff'
const backgroundBlue2 = '#eef3ff'
const backgroundGray = '#e3e3e3'
const backgroundGray1 = '#f6f6f6'
const backgroundGreen = '#dbfaed'
const backgroundOrange = '#fcecdd'
const backgroundOrange1 = '#fff6ee'
const backgroundRed = '#f9dbdb'
const backgroundRedLight = 'rgb(255 241 241)'
const backgroundRedLightHover = 'rgb(255 227 227)'
const transparentGray = 'rgba(0, 0, 0, 0.2)'
const backgroundPurple1 = '#9481ff4f'
const backgroundHover1 = '#fbfcfd'
const backgroundHover2 = '#f7f9fc'

// Green Scale
const green1 = '#67E5AF'
const green2 = '#36BB85'
const green3 = '#4CE2A7'

// Red Scale
const red1 = '#E05752'
const red2 = '#ED6A5E'
const red3 = '#db7f8e'
const red4 = '#fef3f3'

// Orange Scale
const orange = '#F47735'
const orange1 = '#F1A153'
const orange2 = '#FFA863'

// Purple Scale
const purple1 = '#9381FF'
const purple2 = '#522689'

// Yellow scale
const yellow1 = '#FCC449'

// Text Colors

const colors = {
  inherit: 'inherit',
  black: '#000000',
  orange,
  orange1,
  orange2,
  white: '#FFFFFF',
  green: '#4CE2A7',
  red: '#E24C4C',
  red1,
  red2,
  red3,
  red4,
  yellow: '#F1A153',
  blue1,
  blue2,
  blue3,
  blue4,
  blue5,
  blue6,
  blue7,
  blue8,
  blue9,
  blue10,
  gray1,
  gray2,
  gray3,
  gray4,
  gray5,
  gray6,
  gray7,
  gray8,
  gray9,
  gray10,
  gray11,
  gray12,
  gray13,
  gray14,
  gray15,
  grayShadeBlack2,
  green1,
  green2,
  green3,
  purple1,
  purple2,
  yellow1,
  // Theming colors
  defaultBorder: gray4,
  defaultText: gray7,
  disabledText: gray5,
  backgroundBlue,
  backgroundBlue2,
  backgroundGray,
  backgroundGray1,
  backgroundGreen,
  backgroundOrange,
  backgroundOrange1,
  backgroundRed,
  backgroundRedLight,
  backgroundRedLightHover,
  backgroundPurple1,
  backgroundHover1,
  backgroundHover2,
  transparent: 'transparent',
  transparentGray,
}

export type ThemeColor = keyof typeof colors

/**
 * Color function to adjust color tint
 * Accepts positive or negative values to lighten or darken
 */
const AdjustColorTint = (hex: string, value: number) => {
  let color = hex
  let usePound = false

  if (hex[0] === '#') {
    color = color.slice(1)
    usePound = true
  }

  const num = parseInt(color, 16)
  let r = (num >> 16) + value

  if (r > 255) {
    r = 255
  } else if (r < 0) {
    r = 0
  }

  let b = ((num >> 8) & 0x00ff) + value
  if (b > 255) {
    b = 255
  } else if (b < 0) {
    b = 0
  }

  let g = (num & 0x0000ff) + value
  if (g > 255) {
    g = 255
  } else if (g < 0) {
    g = 0
  }

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}

const HexToRgba = (hex: string, alpha = 1) => {
  const matchedArray = hex.match(/\w\w/g)
  if (matchedArray) {
    const [r, g, b] = matchedArray.map((x) => parseInt(x, 16))
    return `rgba(${r},${g},${b},${alpha})`
  }
}

export type AppColors = typeof colors
export { colors, AdjustColorTint, HexToRgba }
